<template>
  <div v-show="false" />
</template>

<script setup lang="ts">
const props = defineProps<{
  show: Boolean;
}>();

const emits = defineEmits([
  'show',
  'hide',
]);

watch(() => props.show, (show) => {
  if (show) {
    emits('show');
  } else {
    emits('hide');
  }
});
</script>
